




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';
import JobStage from '@/models/Jobs/JobStage';


@Component({
  name: 'JobStage',
})
export default class extends GiganautVue {

	@Prop({required: true})
	stage: JobStage;

	@Prop({required: true})
	location: StatusDisplayLocation;

	get text() {
		let text = "";
		switch (this.stage) {
			case JobStage.Pending:
				text = "PENDING";
				break;
			case JobStage.Shortlisted:
				text = "SHORTLISTED";
				break;
			case JobStage.Interested:
				text = "INTERESTED";
				break;
			case JobStage.InterviewOne:
				text = "INTERVIEW ONE";
				break;
			case JobStage.InterviewTwoPlus:
				text = "INTERVIEW TWO +";
				break;
			case JobStage.Offered:
				text = "OFFERED";
				break;
			case JobStage.Placed:
				text = "PLACED";
				break;
			default:
				text = "UNKNOWN STATUS"
				break;
		}
		return text;
	}
	
	get classy() {
		const classes: string[] = [];
		switch (this.location) {
			case StatusDisplayLocation.Title:
				classes.push("overline");
				classes.push("ma-1");
				break;
			case StatusDisplayLocation.Grid:
				classes.push("overline");
				break;
			case StatusDisplayLocation.SubTitle:
			default:
				classes.push("overline");
				classes.push("ma-1");
				break;
		}
		//classes.push("chevron");
		//classes.push("white--text");
		return classes;
	}
}
